import {BrowserRouter, Routes, Route} from 'react-router-dom'
import './App.css';
import {Header} from "./components/Header";
import {Nav} from "./components/Nav";
import {Main} from "./components/Main";
import {P5} from "./components/P5";
import {A1} from "./components/A1";
import {A2} from "./components/A2";
import {B1} from "./components/B1";
import {B2} from "./components/B2";
import {B3} from "./components/B3";
import {V1} from "./components/V1";
import {V2} from "./components/V2";
import {H1} from "./components/H1";
import {H2} from "./components/H2";
import {G1} from "./components/G1";
import {G2} from "./components/G2";
import {G3} from "./components/G3";

function App() {
    return (
        <BrowserRouter>
            <div className="App">
                <Header/>
                <Nav/>
                <Routes>
                    <Route path='/' element={<Main/>}/>
                    <Route path='/about' element={<P5/>}/>
                    <Route path='/a1' element={<A1/>} />
                    <Route path='/a2' element={<A2/>} />
                    <Route path='/b1' element={<B1/>} />
                    <Route path='/b2' element={<B2/>} />
                    <Route path='/b3' element={<B3/>} />
                    <Route path='/v1' element={<V1/>} />
                    <Route path='/v2' element={<V2/>} />
                    <Route path='/h1' element={<H1/>} />
                    <Route path='/h2' element={<H2/>} />
                    <Route path='/g1' element={<G1/>} />
                    <Route path='/g2' element={<G2/>} />
                    <Route path='/g3' element={<G3/>} />
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;
